<template>
	<div>
		<div v-for="(line, i) in array" :key="line.label" class="lh150">
			<!-- If the content is a value displays it -->
			<div
				v-if="typeof line !== 'object'"
				:class="i != array.length - 1 ? 'bb1 bc7' : ''"
			>
				{{ line.value }}
			</div>
			<!-- If the content is an object or an array displays the component again -->
			<div v-else>
				<endorsements-data-item-array
					v-if="Array.isArray(line)"
					:array="line"
					:class="i != array.length - 1 ? 'bb1 bc7' : ''"
					>{{ line }}</endorsements-data-item-array
				>
				<endorsements-data-item-object
					:class="i != array.length - 1 ? 'bb1 bc7' : ''"
					v-else
					:object="line"
				>
					{{ line }}
				</endorsements-data-item-object>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "EndorsementsDataItemArray",
	components: {
		EndorsementsDataItemArray: () => import("./EndorsementsDataItemArray"),
		EndorsementsDataItemObject: () => import("./EndorsementsDataItemObject")
	},
	props: ["array"]
}
</script>
